import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';
import Icon from '@mdi/react';
import { mdiChevronRight, mdiChevronLeft } from '@mdi/js';
import Badge from '@material-ui/core/Badge';
import { ContactProps } from '../../../shared/prop-types/ChatProps';
import { CHAT_CONTACT_TYPES } from '../../../shared/utils/constants';
import ChatAvatar from '../../../shared/components/ChatAvatar';

const ChatUser = (props) => {
  const { contact, active, onBackClickHandler, t, contactClick } = props;

  const onBtnContactClickHandler = () => {
    if (contactClick) {
      contactClick(contact);
    }
    if (onBackClickHandler) {
      onBackClickHandler();
    }
  };

  const contactClass = classNames({
    chat__contact: true,
    'chat__contact--active': active,
  });

  const color =
    contact.type === CHAT_CONTACT_TYPES.COMMUNICATION_CHANNEL
      ? '#9099FC'
      : '#1CCA42';

  return (
    <span className="tooltip-test" title={contact.name}>
      <button type="button" onClick={() => onBtnContactClickHandler()}>
        <div className={contactClass}>
          {onBackClickHandler ? <Icon path={mdiChevronLeft} size={1} /> : null}
          <Badge badgeContent={contact.unreadMessage} color="error">
            <ChatAvatar
              size="50"
              round="50%"
              name={contact.name}
              color={color}
              urlPhoto={contact.urlProfilePhoto}
            />
          </Badge>
          <div className="chat__contact__info">
            <p className="user-name">{contact.name}</p>
            <p className="user-class-name">{contact.classes}</p>
            <p className="user-subtitle">
              {t(`chat.subtitle.${contact.type}`)}
            </p>
          </div>
          <div>
            {contact.type === CHAT_CONTACT_TYPES.COMMUNICATION_CHANNEL &&
            !onBackClickHandler ? (
              <Icon path={mdiChevronRight} size={1} />
            ) : null}
          </div>
        </div>
      </button>
    </span>
  );
};

ChatUser.propTypes = {
  contact: ContactProps.isRequired,
  active: PropTypes.bool,
  t: PropTypes.func.isRequired,
  onBackClickHandler: PropTypes.func,
  contactClick: PropTypes.func,
};

ChatUser.defaultProps = {
  active: false,
  onBackClickHandler: null,
  contactClick: null,
};

export default withTranslation('common')(memo(ChatUser));
